import { render } from "./ChangeBankAccount.vue?vue&type=template&id=748ec6ca"
import script from "./ChangeBankAccount.vue?vue&type=script&lang=js"
export * from "./ChangeBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__